// extracted by mini-css-extract-plugin
export var width100 = "V_w d_w";
export var design3Pos = "V_yl d_0";